// eslint-disable-next-line
export default {    
    fetchStatus: {
      READY: "READY",
      FETCHING: "FETCHING"
    },
    apiBaseUrl: {        
        development: "https://be-vending-v2.akinons.id",
        production: "https://be-vending-v2.akinons.id", 
        wsServer : "wss://be-vending-v2.akinons.id/ws/",
        video: "https://vendingmachinenode.myappscenter.com", 
        // development: "http://127.0.0.1:8000",
        // production: "http://127.0.0.1:8000", 
        // wsServer : "ws://127.0.0.1:8000/ws/",
        // video: "http://localhost:4000", 
    },
    localStorageKey : {      
      USER: "__selfPaymenttUser",
      ACCESS_TOKEN: "__selfPaymenttToken",      
      PERUSAHAAN : '_selfPaymenttperusahaanInfo',
    },
    cookiesName : 'fww_client',
    expiresSession : 8640000,
    itemPerPage : 10,
    timeOutValue : 10000,
    endPoint : {
      // auth
      createPayment : '/payment/api/v1/payment-xendit/',
      getPayment : '/payment/api/v1/payment/',
      video : `/payment/api/v1/video/`,
      login : `/auth/login-outlet/`,
      invoiceInfo : `/payment/api/v1/get-invoice-info/`,
      masterVa : `/payment/api/v1/master-va/`,
      createVa : `/payment/api/v1/create-va-xendit/`,
      cancelPayment : `/payment/api/v1/cancel-payment/`,
      openMachine : `/payment/api/v1/open-machine/`,

      // pinScreen 
      pinScreen : `/payment/api/v1/pin-screen/`,
      loginPinScreen : `/payment/api/v1/login-pin-screen/`,
      paymentGroup : `/payment/api/v1/payment-group/`,
      resendHook: '/payment/api/v1/resend-callback/',
    }
}
